import React, { ReactElement } from 'react';
import { Button, FormInstance, Space, Spin, Tooltip } from 'antd';
import { DeleteOutlined, PaperClipOutlined } from '@ant-design/icons';
import { Document, Page, pdfjs } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

import {
  FieldFileUploadPreview,
  FieldFileUploadPreviewHeader,
} from 'pricing/components/contract/contractForm/fields/fieldFileUpload/FieldFileUpload.styles';
import { FilePreview } from 'pricing/components/contract/contractForm/fields/fieldFileUpload/FieldFileUpload';
import { testId } from 'pricing/utilities/test/dataTestId';

interface Props {
  filePreview: FilePreview;
  form: FormInstance;
  formItemName: string;
  disabled?: boolean;
}

function FieldFileUploadPreviewer(props: Props): ReactElement {
  const { form, formItemName, filePreview, disabled } = props;
  const handlePreviewContract = () => {
    window
      .open('')
      ?.document.write(
        `<iframe width='100%' height='100%' frameborder="0" border="0" cellspacing="0" src='${filePreview.src}' />`,
      );
  };

  return (
    <FieldFileUploadPreview data-testid={testId.fieldFileUploadPreview}>
      <FieldFileUploadPreviewHeader>
        <Button
          data-testid={testId.fieldFileUploadPreviewButton}
          type="link"
          size="small"
          icon={<PaperClipOutlined />}
          onClick={handlePreviewContract}
        >
          Contract Preview
        </Button>
        <Space className="FieldFileUploadPreviewTools" size={10}>
          {!disabled && (
            <Tooltip title="Remove">
              <DeleteOutlined
                data-testid={testId.fieldFileRemoveUploadButton}
                onClick={() => form.setFieldsValue({ [formItemName]: null })}
              />
            </Tooltip>
          )}
        </Space>
      </FieldFileUploadPreviewHeader>
      {filePreview.isImage && (
        <img
          src={filePreview.src}
          alt="contract-preview"
          data-testid={testId.fieldFileUploadPreviewImg}
        />
      )}
      {filePreview.isPdf && (
        <section data-testid={testId.fieldFileUploadPreviewPdf}>
          <Document file={filePreview.src} loading={<Spin />}>
            <Page width={280} height={262} pageNumber={1} />
          </Document>
        </section>
      )}
    </FieldFileUploadPreview>
  );
}

export default FieldFileUploadPreviewer;
